define(function() {
	var Backbone = require('backbone');
	const IpsModelCollection = require('civicsBase/ipsModelCollection');
	const urlBuilder = require('civicsUtils/buildUrlParameters');

	return IpsModelCollection.extend({
		urlRoot: '/delegate/civics-api/api/portal/instruments/',
		scenarioID:null,
		url:function(){
			if(this.scenarioID){
				var parms = urlBuilder.buildUrlParameters({
					extendedFilter:{
						And:[{
							property:'Scenario',
							value:this.scenarioID,
							operator:'equal'
						}]
					}
				});
				return this.urlRoot+parms;
			}
			return '';
		},
		parse: function(response) {
			this.responseStatus = response.responseStatus;
			return response.data;
		},
	});
});
